var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"py-1 mb-0",class:_vm.textColor && `${_vm.textColor}--text`,attrs:{"sentry-tag":"text-message"},domProps:{"innerHTML":_vm._s(_vm.text)}})
}
var staticRenderFns = []

export { render, staticRenderFns }